import React from 'react';
import ReactSelect from 'react-select';
import styled from 'styled-components';
import { color } from 'styled-system';
import PropTypes from 'prop-types';

import { Label } from '../FormStyles';

const SelectWrapper = styled.div`
  font-family: 'Montserrat', sans-serif;
`;

const InputLabel = styled(Label)`
  margin: 0;
  line-height: 22px;
`;

const CircleExclamationIcon = styled.i`
  margin: 0 4px;
`;

CircleExclamationIcon.defaultProps = {
  className: 'fa-regular fa-circle-exclamation'
};

const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 8px;
`;

const ErrorMessage = styled.span`
  ${color};
  margin-left: auto;
  font-size: 14px;
  font-weight: 400;
`;

const CustomSelect = styled(ReactSelect)`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
`;

const customStyles = {
  valueContainer: provided => ({
    ...provided,
    padding: '11px 16px',
  }),
  control: provided => ({
    ...provided,
    background: 'transparent',
    borderRadius: '8px',
    borderColor: '#DBDDE0',
    cursor: 'pointer',
  }),
  placeholder: provided => ({
    ...provided,
    color: '#CACCCF',
  }),
  menuList: provided => ({
    ...provided,
    color: '#25282B',
    textAlign: 'left',
  }),
  indicator: provided => ({
    ...provided,
    color: '#25282B',
  }),
};

const Select = ({
  id,
  name,
  onChange,
  placeholder,
  options,
  isSearchable,
  isClearable,
  isDisabled = false,
  label,
  dataTooltip,
  error,
  value,
}) => {
  return (
    <SelectWrapper>
      {label && (
        <LabelWrapper>
          <InputLabel htmlFor={id}>{label}</InputLabel>
          {dataTooltip && <CircleExclamationIcon data-tip={dataTooltip} />}
          {error && <ErrorMessage color="error.default">{error}</ErrorMessage>}
        </LabelWrapper>
      )}
      <CustomSelect
        inputId={id}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        options={options}
        isSearchable={isSearchable}
        isClearable={isClearable}
        isDisabled={isDisabled}
        value={value}
        components={{
          IndicatorSeparator: () => null,
        }}
        styles={customStyles}
      />
    </SelectWrapper>
  );
};

Select.propTypes = {
  onChange: PropTypes.func,
  isSearchable: PropTypes.bool,
  isClearable: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onBlur: PropTypes.func,
  error: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
      ]),
      label: PropTypes.string,
    }),
  ),
  dataTooltip: PropTypes.string,
  placeholder: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
    ]),
    label: PropTypes.string,
  }),
};

export default Select;
